<template>
  <sidenav :orientation="orientation" :class="curClasses">

    <!-- Inner -->
    <div class="sidenav-inner" :class="{ 'py-1': orientation !== 'horizontal' }">

      <book-navigator></book-navigator>

    </div>
  </sidenav>
</template>

<script>
import { Sidenav, SidenavLink, SidenavRouterLink, SidenavMenu, SidenavHeader, SidenavBlock, SidenavDivider } from '@/vendor/libs/sidenav'
import BookNavigator from './../components/program/BookNavigator.vue'

export default {
    name: 'app-layout-sidenav-1',
    components: {
        Sidenav,
        SidenavLink,
        SidenavRouterLink,
        SidenavMenu,
        SidenavHeader,
        SidenavBlock,
        SidenavDivider,
        'book-navigator': BookNavigator
},

    props: {
        orientation: {
            type: String,
            default: 'vertical'
        }
    },

    computed: {
        curClasses () {
            let bg = this.layoutSidenavBg

            if (this.orientation === 'horizontal' && (bg.indexOf(' sidenav-dark') !== -1 || bg.indexOf(' sidenav-light') !== -1)) {
                bg = bg
                    .replace(' sidenav-dark', '')
                    .replace(' sidenav-light', '')
                    .replace('-darker', '')
                    .replace('-dark', '')
            }

            return `bg-${bg} ` + (
                this.orientation !== 'horizontal'
                    ? 'layout-sidenav'
                    : 'layout-sidenav-horizontal container-p-x flex-grow-0'
            )
        }
    },

    methods: {
        isMenuActive (url) {
            return this.$route.path.indexOf(url) === 0
        },

        isMenuOpen (url) {
            return this.$route.path.indexOf(url) === 0 && this.orientation !== 'horizontal'
        },

        toggleSidenav () {
            this.layoutHelpers.toggleCollapsed()
        }
    }
}
</script>
